import { useState } from 'react';
import useApi from '@/lib/api/useApi';
import useIsPortfolioReadonly from '../../useIsPortfolioReadonly';
import { type TaskSummary } from '@/lib/types';

const useMarkCoachCommentsAsReadOnLoad = (
  task: TaskSummary,
  loading: boolean,
): void => {
  const api = useApi();

  const portfolioIsReadonly = useIsPortfolioReadonly();
  const [markedAsRead, setMarkedAsRead] = useState(false);

  const markCoachCommentsAsRead = (): void => {
    setMarkedAsRead(true);

    api.post(`challenge-portfolio/tasks/${task.id}/coach-comments/read`);
  };

  if (!loading && !markedAsRead && !portfolioIsReadonly) {
    markCoachCommentsAsRead();
  }
};

export default useMarkCoachCommentsAsReadOnLoad;
